//src/components/Carousel/Carousel.js
import { useState } from "react";
import "./Carousel.scss";

function Carousel({ images = [] }) {
  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };

  if (!images.length) return null;

  return (
    <div className="Carousel">
      {images.length > 1 && (
        <button
          className="carousel-arrow left"
          onClick={prev}
          aria-label="Image précédente"
        >
          ❮
        </button>
      )}

      <img
        src={
          typeof images[index] === "string" ? images[index] : images[index].src
        }
        alt={
          typeof images[index] === "string"
            ? "Capture du projet"
            : images[index].alt
        }
        className="carousel-image"
      />

      {images.length > 1 && (
        <button
          className="carousel-arrow right"
          onClick={next}
          aria-label="Image suivante"
        >
          ❯
        </button>
      )}
    </div>
  );
}
export default Carousel;
